<template>
<div style="width:100%;min-height:800px;min-width:1000px" >
    <br/>
     <Row><Col span="12" offset="10"><div class="myTitle" >疑似线索列表</div></Col></Row>
    <br>

    <Row>
        <Col span="24">
            <Row>
                <div class="queryForm">
                    <Form ref="queryFormRef" :model="queryForm" :label-width="70" inline>                       
                      
                         <FormItem label="线索名称" prop="title" >
                            <Input v-model="queryForm.title" placeholder="线索名称 "></Input>
                        </FormItem>
                         <FormItem label="类别" prop="category">
                                <Select  v-model="queryForm.category"  :clearable="true"  :transfer="true">
                                    <Option value="旅游">旅游</Option>
                                    <Option value="文化">文化</Option>
                                    <Option value="票务">票务</Option>
                                    <Option value="舆情">舆情</Option>
                                </Select>
						</FormItem>
                         <FormItem label="违规类型" prop="tag">
                                <Select  v-model="queryForm.tag"  :clearable="true"  :transfer="true" style="width:200px">
                                    <Option value="涉嫌未经许可经营旅行社业务">涉嫌未经许可经营旅行社业务</Option>
                                    <Option value="涉嫌低价游产品">涉嫌低价游产品</Option>
                                    <Option value="涉嫌未经许可经营演出票务活动">涉嫌未经许可经营演出票务活动</Option>
                                    <Option value="涉嫌外籍人士违规演出">涉嫌外籍人士违规演出</Option>
                                    <Option value="涉嫌发布违规网络文化产品">涉嫌发布违规网络文化产品</Option>
                                    <Option value="其他">其他</Option>
                                </Select>
						</FormItem>
                         <FormItem label="加入时间："  :label-width="80">
                          <DatePicker type="date" placeholder="开始时间" format="yyyy-MM-dd"
                            v-model="queryForm.startDate" @on-change="queryForm.startDate=$event" ></DatePicker>
                          ——
                          <DatePicker type="date" placeholder="结束时间"
                              v-model="queryForm.endDate" format="yyyy-MM-dd"  @on-change="queryForm.endDate=$event" ></DatePicker>
                       </FormItem>
                        <Button type="info"  @click="queryBtn" >查询</Button>
	                    <Button type="success"  @click="resetQueryForm">重置</Button>
                    </form>
                </div>
            </Row>
               <Row >
                <Col span="20" offset="1">
                    <div style="float:left">
                    
                    <Button type="success"   @click="openExport()">导出</Button>&nbsp;&nbsp;&nbsp;
                    
                    
                    </div>
                </Col>
          </Row>
      <br>
            <Row>
                <Col span="24">
                        <Table :loading="loading" @on-selection-change="selectRow"
                               border ref="table" stripe :columns="columns4" :data="listData">
                            <template slot-scope="{ row }" slot="name">
                                <strong>{{ row.name }}</strong>
                            </template>
                             <template slot-scope="{ row }" slot="action">
                               <Button type="info" size="small" @click="updatePage(row)">加入确认线索</Button>
                                <Button type="error" size="small" @click="deleteRows(row)">删除</Button>
                            </template>
                        </Table>
                 </Col>
            </Row>
            <Row>
                <Col span="24">
                	<div>
                        <Footer>
                            <Page show-sizer show-total :total="rowCount" :current="current"
                                  :page-size="pageSize"  @on-change="changePage"
                                  @on-page-size-change="changeSize" />
                        </Footer>
                    </div>
            	</Col>
            </Row>
        </Col>
    </Row>
       <AddConfirm ref="addConfirm"></AddConfirm>
    </div>
    
</template>

<script>
     import AddConfirm from '@/pages/platform/suspected/addConfirm';
     import '../../../assets/icons/iconfont/iconfont.css';
     import  downloadTemplate   from "@/utils/downloadFile";
     import moment from 'moment'
    
    export default {
         components: {
               AddConfirm
          },
        methods: {
          
           
       //执行删除操作
            deleteRows(row) {
               
                this.$Modal.confirm({
                    title: '删除',
                      content: `确认要删除吗?`,
                    onOk: () => {
                         this.loading = true
                         let url = `/api/data/clue`
                            this.req({
                                url: url,
                                method: 'delete',
                                data: {
                                    _id: row._id,
                                     type: 4,
                                     isClue:0   //疑似线索
                                }
                            }).then(response => {
                                this.$Message.success(
                                {
                                    content:response.data.msg,
                                    top: 80,
                                    onClose: ()=>{
                                        this.loading = false
                                        this.loadPage();
                                    }
                                }
                                )
                        }).catch(error => {
                                this.$Message.error('服务器错误:' + error)
                        })
                    },
                    onCancel: () => {
                       // this.loading = false
                    }
                });

            },
               //导出
                openExport(){
                       let url = `/api/data/clue`
                       let  _startDate= this.queryForm.startDate
                        if(this.queryForm.startDate!=''){
                            _startDate=  moment(this.queryForm.startDate).format('YYYY-MM-DD')
                        }
                        let  _endDate= this.queryForm.endDate
                        if(this.queryForm.endDate!=''){
                            _endDate=  moment(this.queryForm.endDate).format('YYYY-MM-DD')
                        }
                    this.req({
                        url: url,
                        method: 'post',
                        responseType: "arraybuffer",
                       data:{
                        type:5,
                        title: this.queryForm.title,
                        category: this.queryForm.category,
                        tag:  this.queryForm.tag,
                        startTime:_startDate,
                        endTime:_endDate,
                        source: "",
                        isClue:  0,    //疑似线索   //parseInt(this.queryForm.isClue),
                        p: this.current,
                        pageSize: this.pageSize,
                        }
                    }).then(response => {
                        downloadTemplate.fileDownload(response.data, "list.xlsx");
                    }).catch(error => {
                        this.$Message.error('服务器错误:' + error)
                    })
                },
            loadPage() {
                let url = `/api/data/clue`
                let  _startDate= this.queryForm.startDate
                    if(this.queryForm.startDate!=''){
                        _startDate=  moment(this.queryForm.startDate).format('YYYY-MM-DD')
                    }
                    let  _endDate= this.queryForm.endDate
                    if(this.queryForm.endDate!=''){
                        _endDate=  moment(this.queryForm.endDate).format('YYYY-MM-DD')
                    }
                this.req({
                    url: url,
                    method: 'post',
                    data:{
                      type:2,
                      title: this.queryForm.title,
                      category: this.queryForm.category,
                      tag:  this.queryForm.tag,
                      startTime:_startDate,
				      endTime:_endDate,
                      source: "",
                      isClue:  0,    //疑似线索   //parseInt(this.queryForm.isClue),
                      p: this.current,
                      pageSize: this.pageSize,
                    }
                }).then(resp => {
                    
                    if(resp.data.code==200){
                        this.buildPageData(resp.data.page)
                        }else{
                            this.$Message.error(resp.data.msg);
                            if(resp.data.msg=="缺少参数token"){
                                this.$Message.error("登录过期，请重新登录");
                                this.$router.push("/login");
                            }
                    }
                    this.loading = false
                }).catch(error => {
                   this.$Message.error('服务器错误:' + error)
            	})
            },
             
             //修改线索（疑似、确认）
             updatePage(row) {
                
                  this.$refs.addConfirm.openModal('添加确认线索',row);
                /*  let url = `/api/data/clue`
                    this.req({
                        url: url,
                        method: 'post',
                        data:{
                        type:3,
                        _id:     row.id ,//this.queryForm._id,
                        isClue:  parseInt(this.queryForm.isClue),
                        }
                    }).then(resp => {
                        	if(resp.data.code==200){
								this.$Message.info(resp.data.msg)
								}else{
									this.$Message.error(resp.data.msg);
									if(resp.data.msg=="缺少参数token"){
										this.$Message.error("登录过期，请重新登录");
										this.$router.push("/login");
									}
							}
                        this.loading = false
                    }).catch(error => {
                    this.$Message.error('服务器错误:' + error)
                    })*/
            },
            changePage(curPage) {
                this.loading = true
                this.current = curPage
                this.loadPage()
            },

            changeSize(pageSize) {
                this.pageSize = pageSize
                this.loading = true
                this.loadPage()
            },
            buildPageData(dataObj) {
                this.listData = dataObj.list;
                this.pageSize = dataObj.size;
                this.rowCount = dataObj.rowCount;
                this.currentPage = dataObj.p;
            },
            queryBtn(){
                this.current = 1
                this.loadPage()
            },
           
            selectRow(selection) {
                this.selectRows = selection;
            },
            resetQueryForm() {
             	this.$refs["queryFormRef"].fields.forEach(function (e) {
		           e.resetField()
		        })
            },
           
          
           
         
        },
       
        mounted: function () {
            this.loadPage()
        },
        data() {
            return {
                listData: [],
                pageSize: 10,
                current: 1,
                rowCount: 0,
                loading: true,
                selectRows: [],
                deleteIds: [],
                columns4: [{
                        type: 'index',
                        title: '序号',
	                    width: 60,
	                    align: 'center',
                    },
                    {
                        title: '线索',
                        key: 'title' ,
                        align: 'center',
                         render:(h,params)=>{
                             let text=''
                           /**  let change='';
                            if(params.row.isClue==1){
                               change='  <select id="myselect'+params.row._id+'"  onchange=toWaringInfo("'+params.row._id+'","'+params.index+'")  class="myselect"> <option value="确认线索">确认线索</option><option value="疑似线索">疑似线索</option></select>'
                             }else  if(params.row.isClue==0){
                               change='  <select id="myselect'+params.row._id+'"  onchange=toWaringInfo("'+params.row._id+'","'+params.index+'")  class="myselect2"> <option value="确认线索" >确认线索</option> <option selected value="疑似线索">疑似线索</option></select>'
                             } */
                             text='<div>'+
                             '<div style="float:left;text-align:left;"><div><span  style="color:#000;font-size:12px;font-weight:600"><a target="+blank" href='+params.row.url+'>'+params.row.title+'</a></span>'+
                             ' </div>';
                             if(params.row.content!=''&&params.row.content!=undefined){
                                text+='<div>'+ params.row.content+'</div> '
                              }
                              if(params.row.info!=''&&params.row.info!=undefined){
                                text+='<div class="info">'+ params.row.info+'</div>'
                              }
                              if(params.row.img.length>0){
									text+=' <div class="imgWrap">'
									for(let i=0;i<params.row.img.length&&i<5;i++){
										text+='<div class="imgContent" > '+
										     '<img class="" src="'+params.row.img[i] +' " style="height: 100px;"> </div>'
									}
									
									text+=' </div>'
								}
                            
                              text+='<div >'
                              if(params.row.source!=''&&params.row.source!=undefined){
                                text+=' '+
                                '<i class="iconfont" style="font-size: 16px;">&#xe62e;</i>  <span> '+params.row.source+'&nbsp;&nbsp; </span>'   
                              }
                               if(params.row.type!=''&&params.row.type!=undefined){
									text+='  '+
									'<i class="iconfont" style="font-size: 16px;">&#xe738;</i><span style="color: #2A5585;"> '+params.row.type+' &nbsp;&nbsp;</span>'   
								}
								if(params.row.minPrice!=''&&params.row.minPrice!=undefined){
									text+='  '+
									'<i class="iconfont" style="font-size: 16px;">&#xe695;</i><span style="color: #2A5585;"> '+params.row.minPrice+'元 &nbsp;&nbsp;</span>'   
								}
								if(params.row.supplierInfo!=''&&params.row.supplierInfo!=undefined){
									text+='  '+
									'<i class="iconfont" style="font-size: 16px;">&#xe62f;</i><span style="color: #2A5585;" > '+params.row.supplierInfo+' &nbsp;&nbsp;</span>'   
								}
								
								if(params.row.releaseTime!=''&&params.row.releaseTime!=undefined){
									text+=''+
									'<i class="iconfont" style="font-size: 16px;">&#xe74f;</i><span style="color:#2A5585"> '+params.row.releaseTime+'</span>'   
								}
								if(params.row.inProvince==0){
									text+=''+
									'<i class="iconfont" style="font-size: 16px;">&#xe62c;</i><span style="color:#2A5585"> 省外</span>'   
								}else{
									text+=''+
									'<i class="iconfont" style="font-size: 16px;">&#xe62c;</i><span style="color:#2A5585">陕西省</span>'   
								}
								if(params.row.venue!=''&&params.row.venue!=undefined){
									text+=''+
									'<i class="iconfont" style="font-size: 16px;">&#xe73a;</i><span style="color:#2A5585"> '+params.row.venue+'</span>'   
								}
                              text+='</div></div></div>'
                              return h("div",{domProps:{
                                innerHTML:`<div href=`+params.row.url+` target='_blank'>`+text+`</div>`
                            }})
                        }
                    },{
                        title: '类别',
                        width:100,
                        key: 'category' ,
                        align: 'center',
                    },{
                        title: '违规类型',
                        width:100,
                        key: 'tag' ,
                        align: 'center',
                    },{
                        title: '线索添加人',
                        width:100,
                        key: 'taskExecutor' ,
                        align: 'center',
                    },{
                        title: '加入时间',
                        width:100,
                        key: 'createTime' ,
                        align: 'center',
                    },{
                        title: '参考低价',
                        width:100,
                        key: 'low_price_price' ,
                        align: 'center',
                    },{
                        title: '参考数据添加时间',
                        width:100,
                        key: 'low_price_createTime' ,
                        align: 'center',
                    },{
                        title: '操作',
                        slot: 'action',
                        width:180,
                        align: 'center',
                    }
                ],

                //查询表单的初始值
                queryForm: {
                    title:'',
                    tag:'',
                    category:'',
                    _id:'',
                    startDate:'',
                    endDate:'',
                }
            }
        },
        

    }

   


</script>

<style>
.myTitle{
      font-size: 20px;
      font-weight: 700;
     }
.icon {
        width: 1em;
        height: 1em;
        vertical-align: -0.15em;
        fill: currentColor;
        overflow: hidden;
    }
.myselect{
    background-color: #fcb9b7;
}
.myselect2{
    background-color: #ffdc70;
}
.myselect3{
    background-color: #a8dfef;
}
 .info em {
    color: #F65177!important;
}
</style>


// WEBPACK FOOTER //
// src/pages/platform/suspected/SuspectedList.vue